module.exports = __webpack_public_path__ + "media/images/features/personal_profile_img-19e1a20bc9c5e36c9e1d7beaa42d7cb7.png";